import { LoaderFunctionArgs, MetaFunction, json } from "@remix-run/node";
import { useLocation } from "@remix-run/react";
import CellShadeWrapper from "~/components/CellShadeWrapper";
import TwitchLoginButton from "~/components/TwitchLoginButton";
import { isAuthenticated } from "~/services/auth.server";

export const meta: MetaFunction = () => [
  { title: "Login to continue | Gremgacha" },
];

export const loader = async ({ request }: LoaderFunctionArgs) => {
  await isAuthenticated(request, {
    successRedirect: "/",
  });

  return json({});
};

export default function Login() {
  const location = useLocation();
  const returnTo = new URLSearchParams(location.search).get("returnTo") ?? "/";

  return (
    <div className="absolute left-1/2 top-1/2 flex w-80 -translate-x-1/2 -translate-y-1/2 transform flex-col items-center rounded-md border border-gray-400 px-4 py-4 md:w-96 md:px-12">
      <h1 className="text-4xl">Gremgacha</h1>
      <h1 className="text-xl">Please login to trade or stuff</h1>
      <div className="my-4 h-[1px] w-full bg-gray-400"></div>
      <CellShadeWrapper
        outerClassName="rounded-md"
        innerClassName="rounded-md border border-black bg-[#6441a5]"
      >
        <TwitchLoginButton returnTo={returnTo} />
      </CellShadeWrapper>
    </div>
  );
}
